module.exports = __webpack_public_path__ + "img/5.af8c342e.png";